import Vue from 'vue'
import Vuex from 'vuex'
import common from "./module/common"
import location from "./location/location"
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    location
  }
})
